import React, { useReducer } from 'react';
import clienteAxios from '../../config/axios';

import XtareaContext from './xtareaContext';
import XtareaReducer from './xtareaReducer';
import {
    XTAREAS_PROYECTO,
    AGREGAR_XTAREA,
    VALIDAR_XTAREA,
    ELIMINAR_XTAREA,    
    XTAREA_ACTUAL,
    ACTUALIZAR_XTAREA,
    LIMPIAR_XTAREA
} from '../../types';

const XtareaState = props => {
    const initialState = {
        xtareasproyecto: [],
        errorxtarea: false,
        xtareaseleccionada: null
    }

    // Crear dispatch y state
    const [state, dispatch] = useReducer(XtareaReducer, initialState);

    // crear las funciones
    // obtener las tareas de un proyecto
    const obtenerXtareas = async proyecto => {
        //console.log(proyecto);
        try {            
            const resultado = await clienteAxios.get('/api/tareas', {params: {proyecto}});
            //console.log(resultado);
            dispatch({
                type: XTAREAS_PROYECTO,
                payload: resultado.data.tareas
            })
        } catch (error) {
            console.log(error);
        }
        
    }

    // Agregar tarea extra al proyecto seleccionado
    const agregarXtarea =  async xtarea => {
        try {
            const resultado = await clienteAxios.post('/api/tareas', xtarea);
            //console.log(resultado);
            dispatch({
                type: AGREGAR_XTAREA,
                payload: resultado.data.tarea
            })
        } catch (error) {
            console.log(error);
        }
        
    }

    // valida y muestra un error en caso de ser necesario
    const validarXtarea = () => {
        dispatch({
            type: VALIDAR_XTAREA
        })
    }

    // eliminar xtarea por id
    const eliminarXtarea = async (id, proyecto) => {
        try {
            await clienteAxios.delete(`/api/tareas/${id}`, {params: {proyecto}})
            dispatch({
                type: ELIMINAR_XTAREA,
                payload: id
            })
        } catch (error) {
            console.log(error);
        }
    }

    // cambia el estado de cada xtarea
    // const cambiarEstadoXtarea = xtarea => {
        
    //     dispatch({
    //         type: ESTADO_XTAREA,
    //         payload: xtarea
    //     })
    // }

    //Edita o modifica una tarea
    const actualizarXtarea = async xtarea => {
        
        try {
            const resultado = await clienteAxios.put(`/api/tareas/${xtarea._id}`, xtarea);
            //console.log(resultado);
            dispatch({
                type: ACTUALIZAR_XTAREA,
                payload: resultado.data.tarea
            })
        } catch (error) {
            console.log(error);
        }
        
    }

    // Selecciona una xtarea para edicion (xtarea actual)
    const guardarXtareaActual = xtarea => {
        dispatch({
            type: XTAREA_ACTUAL,
            payload: xtarea
        })
    }

    

    // remueve la xtarea recien editada
    const limpiarXtarea = () => {
        dispatch({
            type: LIMPIAR_XTAREA
        })
    }

    return (
        <XtareaContext.Provider
            value={{
                
                xtareasproyecto: state.xtareasproyecto,
                errorxtarea: state.errorxtarea,
                xtareaseleccionada: state.xtareaseleccionada,
                obtenerXtareas,
                agregarXtarea,
                validarXtarea,
                eliminarXtarea,                
                guardarXtareaActual,
                actualizarXtarea,
                limpiarXtarea
            }}
        >
            {props.children}
        </XtareaContext.Provider>
    )
}

export default XtareaState;